/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const pianoModelMap = [{
  type: "Klavier Schutzhüllen",
  urlTail: "products/klavier-schutzhullen",
  models: [{
    name: "Bechstein A-112",
    value: "bis 120 cm",
  }, {
    name: "Bechstein A-116",
    value: "bis 120 cm",
  }, {
    name: "Bechstein A-124",
    value: "bis 130 cm",
  }, {
    name: "Bechstein B-112",
    value: "bis 120 cm",
  }, {
    name: "Bechstein B-116",
    value: "bis 120 cm",
  }, {
    name: "Bechstein B-124",
    value: "bis 130 cm",
  }, {
    name: "Bechstein Opus-114",
    value: "bis 120 cm",
  }, {
    name: "C. Bechstein A-114 Compact",
    value: "bis 120 cm",
  }, {
    name: "C. Bechstein A-114 Modern",
    value: "bis 120 cm",
  }, {
    name: "C. Bechstein A-124",
    value: "bis 130 cm",
  }, {
    name: "C. Bechstein Classic-118",
    value: "bis 120 cm",
  }, {
    name: "C. Bechstein Classic-124",
    value: "bis 130 cm",
  }, {
    name: "C. Bechstein Concert-8",
    value: "bis 140 cm",
  }, {
    name: "C. Bechstein Contour-118",
    value: "bis 120 cm",
  }, {
    name: "C. Bechstein Elegance-124",
    value: "bis 130 cm",
  }, {
    name: "C. Bechstein Millenium-116",
    value: "bis 120 cm",
  }, {
    name: "Blüthner A-112",
    value: "bis 130 cm",
  }, {
    name: "Blüthner B-132",
    value: "bis 140 cm",
  }, {
    name: "Blüthner C-118",
    value: "bis 120 cm",
  }, {
    name: "Boston 118 E",
    value: "bis 120 cm",
  }, {
    name: "Boston 126 E",
    value: "bis 130 cm",
  }, {
    name: "Boston 132 E",
    value: "bis 140 cm",
  }, {
    name: "Bösendorfer 120",
    value: "bis 120 cm",
  }, {
    name: "Bösendorfer 130",
    value: "bis 130 cm",
  }, {
    name: "Essex 108 C",
    value: "bis 110 cm",
  }, {
    name: "Essex 116 C",
    value: "bis 120 cm",
  }, {
    name: "Essex 123 E",
    value: "bis 130 cm",
  }, {
    name: "Feurich F-112",
    value: "bis 130 cm",
  }, {
    name: "Feurich 112-REE",
    value: "bis 130 cm",
  }, {
    name: "Förster 116 SUPER C",
    value: "bis 120 cm",
  }, {
    name: "Förster 116 SUPER D",
    value: "bis 120 cm",
  }, {
    name: "Förster 116 SUPER E",
    value: "bis 120 cm",
  }, {
    name: "Förster 125G",
    value: "bis 130 cm",
  }, {
    name: "Grotrian-Steinweg 108",
    value: "bis 110 cm",
  }, {
    name: "Grotrian-Steinweg 112 Schulpiano",
    value: "bis 120 cm",
  }, {
    name: "Grotrian-Steinweg 112 A",
    value: "bis 130 cm",
  }, {
    name: "Grotrian-Steinweg 112 V",
    value: "bis 130 cm",
  }, {
    name: "Grotrian-Steinweg Carat-116",
    value: "bis 120 cm",
  }, {
    name: "Grotrian-Steinweg Carat-118",
    value: "bis 120 cm",
  }, {
    name: "Grotrian-Steinweg Classic-124",
    value: "bis 130 cm",
  }, {
    name: "Grotrian-Steinweg Clou",
    value: "bis 120 cm",
  }, {
    name: "Grotrian-Steinweg Concertino-132",
    value: "bis 140 cm",
  }, {
    name: "Grotrian-Steinweg Contour",
    value: "bis 120 cm",
  }, {
    name: "Haessler 115",
    value: "bis 120 cm",
  }, {
    name: "Haessler 124",
    value: "bis 130 cm",
  }, {
    name: "Irmler 118",
    value: "bis 120 cm",
  }, {
    name: "Irmler 122",
    value: "bis 130 cm",
  }, {
    name: "Kawai CE-7",
    value: "bis 110 cm",
  }, {
    name: "Kawai CX 4",
    value: "bis 110 cm",
  }, {
    name: "Kawai CX 5",
    value: "bis 110 cm",
  }, {
    name: "Kawai CX 5 H",
    value: "bis 110 cm",
  }, {
    name: "Kawai E-200",
    value: "bis 120 cm",
  }, {
    name: "Kawai K-2",
    value: "bis 120 cm",
  }, {
    name: "Kawai K-3",
    value: "bis 130 cm",
  }, {
    name: "Kawai K-5",
    value: "bis 130 cm",
  }, {
    name: "Kawai K-15",
    value: "bis 110 cm",
  }, {
    name: "Kawai K-200",
    value: "bis 120 cm",
  }, {
    name: "Kawai K-300",
    value: "bis 130 cm",
  }, {
    name: "Kawai K-500",
    value: "bis 130 cm",
  }, {
    name: "Kawai K-600",
    value: "bis 140 cm",
  }, {
    name: "Kemble Cambridge",
    value: "bis 120 cm",
  }, {
    name: "Kemble K-109",
    value: "bis 110 cm",
  }, {
    name: "Kemble K-121",
    value: "bis 130 cm",
  }, {
    name: "Petrof 115",
    value: "bis 120 cm",
  }, {
    name: "Pfeiffer 112",
    value: "bis 120 cm",
  }, {
    name: "Pfeiffer 114",
    value: "bis 120 cm",
  }, {
    name: "Pfeiffer 118",
    value: "bis 120 cm",
  }, {
    name: "Pfeiffer 118 Tradition",
    value: "bis 120 cm",
  }, {
    name: "Rönisch 115 K",
    value: "bis 120 cm",
  }, {
    name: "Rönisch 115 M",
    value: "bis 120 cm",
  }, {
    name: "Rönisch 118 K",
    value: "bis 120 cm",
  }, {
    name: "Rönisch 123 KN",
    value: "bis 130 cm",
  }, {
    name: "Rönisch 123 KS",
    value: "bis 130 cm",
  }, {
    name: "Rönisch 132 KM",
    value: "bis 140 cm",
  }, {
    name: "Sauter 108 Studio",
    value: "bis 110 cm",
  }, {
    name: "Sauter 114 Carus",
    value: "bis 120 cm",
  }, {
    name: "Sauter 116 Schulklavier",
    value: "bis 120 cm",
  }, {
    name: "Sauter 122 Schulklavier",
    value: "bis 130 cm",
  }, {
    name: "Sauter Competence 130",
    value: "bis 130 cm",
  }, {
    name: "Sauter Ragazza 112",
    value: "bis 120 cm",
  }, {
    name: "Schimmel 105",
    value: "bis 110 cm",
  }, {
    name: "Schimmel 112/5",
    value: "bis 120 cm",
  }, {
    name: "Schimmel 114 Modern",
    value: "bis 120 cm",
  }, {
    name: "Schimmel 112 Schulklavier",
    value: "bis 120 cm",
  }, {
    name: "Schimmel 116 SC",
    value: "bis 120 cm",
  }, {
    name: "Schimmel 116 ST",
    value: "bis 120 cm",
  }, {
    name: "Schimmel 130 Tradition",
    value: "bis 130 cm",
  }, {
    name: "Schimmel C-116 Tradition",
    value: "bis 120 cm",
  }, {
    name: "Schimmel C-120 Traditional",
    value: "bis 120 cm",
  }, {
    name: "Schimmel C-120 Schulklavier",
    value: "bis 120 cm",
  }, {
    name: "Schimmel C-120 Tradition",
    value: "bis 120 cm",
  }, {
    name: "Schimmel K-112",
    value: "bis 130 cm",
  }, {
    name: "Schimmel K-125",
    value: "bis 130 cm",
  }, {
    name: "Schimmel K-132",
    value: "bis 140 cm",
  }, {
    name: "Schimmel Vogel",
    value: "bis 120 cm",
  }, {
    name: "Seiler 110",
    value: "bis 110 cm",
  }, {
    name: "Seiler 116 Favorit",
    value: "bis 120 cm",
  }, {
    name: "Seiler 116 Primus",
    value: "bis 120 cm",
  }, {
    name: "Seiler 116 Mondial",
    value: "bis 120 cm",
  }, {
    name: "Seiler Johannels Seiler 118",
    value: "bis 120 cm",
  }, {
    name: "Seiler 122 Primus",
    value: "bis 130 cm",
  }, {
    name: "Seiler 132 Konzert",
    value: "bis 130 cm",
  }, {
    name: "Steinberg C-2",
    value: "bis 130 cm",
  }, {
    name: "Steinberg C-6",
    value: "bis 120 cm",
  }, {
    name: "Steinberg IQ-16",
    value: "bis 120 cm",
  }, {
    name: "Steinberg IQ-20",
    value: "bis 120 cm",
  }, {
    name: "Steinberg IQ-24",
    value: "bis 130 cm",
  }, {
    name: "Steingraeber & Söhne 122",
    value: "bis 130 cm",
  }, {
    name: "Steingraeber & Söhne 128",
    value: "bis 130 cm",
  }, {
    name: "Steingraeber & Söhne 138",
    value: "bis 140 cm",
  }, {
    name: "Steinway & Sons K-130",
    value: "bis 130 cm",
  }, {
    name: "Steinway & Sons K-132",
    value: "bis 140 cm",
  }, {
    name: "Steinway & Sons V-125",
    value: "bis 130 cm",
  }, {
    name: "Steinway & Sons Z-114",
    value: "bis 120 cm",
  }, {
    name: "W. Hoffmann P-120",
    value: "bis 120 cm",
  }, {
    name: "W. Hoffmann T-122",
    value: "bis 130 cm",
  }, {
    name: "W. Hoffmann T-126",
    value: "bis 130 cm",
  }, {
    name: "W. Hoffmann T-128",
    value: "bis 130 cm",
  }, {
    name: "W. Hoffmann V-112",
    value: "bis 120 cm",
  }, {
    name: "W. Hoffmann V-120",
    value: "bis 130 cm",
  }, {
    name: "W. Hoffmann V-128",
    value: "bis 130 cm",
  }, {
    name: "Yamaha B-1",
    value: "bis 110 cm",
  }, {
    name: "Yamaha B-2",
    value: "bis 120 cm",
  }, {
    name: "Yamaha B-3",
    value: "bis 130 cm",
  }, {
    name: "Yamaha C-108",
    value: "bis 110 cm",
  }, {
    name: "Yamaha E-110",
    value: "bis 110 cm",
  }, {
    name: "Yamaha LU-101",
    value: "bis 110 cm",
  }, {
    name: "Yamaha LU-201",
    value: "bis 120 cm",
  }, {
    name: "Yamaha M-1",
    value: "bis 110 cm",
  }, {
    name: "Yamaha M-5",
    value: "bis 110 cm",
  }, {
    name: "Yamaha P-116",
    value: "bis 120 cm",
  }, {
    name: "Yamaha P-121",
    value: "bis 130 cm",
  }, {
    name: "Yamaha SU-118",
    value: "bis 120 cm",
  }, {
    name: "Yamaha SU-7",
    value: "bis 140 cm",
  }, {
    name: "Yamaha U-1",
    value: "bis 130 cm",
  }, {
    name: "Yamaha U-3",
    value: "bis 140 cm",
  }, {
    name: "Yamaha YUS-1",
    value: "bis 130 cm",
  }, {
    name: "Yamaha YUS-3",
    value: "bis 140 cm",
  }, {
    name: "Yamaha YUS-5",
    value: "bis 140 cm",
  }, {
    name: "Zimmerman Z-3",
    value: "bis 120 cm",
  }],
}, {
  type: "Flügel Schutzhüllen",
  urlTail: "products/flugel-schutzhullen",
  models: [{
    name: "Bechstein A-160",
    value: "bis 160 cm",
  }, {
    name: "Bechstein A-175",
    value: "bis 180 cm"
  }, {
    name: "Bechstein A-189",
    value: "bis 190 cm"
  }, {
    name: "Bechstein A-190",
    value: "bis 190 cm"
  }, {
    name: "Bechstein A-208",
    value: "bis 210 cm"
  }, {
    name: "Bechstein A-228",
    value: "bis 230 cm"
  }, {
    name: "Bechstein B-160",
    value: "bis 160 cm"
  }, {
    name: "Bechstein B-175",
    value: "bis 180 cm"
  }, {
    name: "Bechstein B-190",
    value: "bis 190 cm"
  }, {
    name: "Bechstein B-208",
    value: "bis 210 cm"
  }, {
    name: "Bechstein B-228",
    value: "bis 230 cm"
  }, {
    name: "C. Bechstein A-160",
    value: "bis 160 cm"
  }, {
    name: "C. Bechstein A-175",
    value: "bis 180 cm"
  }, {
    name: "C. Bechstein A-190",
    value: "bis 190 cm"
  }, {
    name: "C. Bechstein A-192",
    value: "bis 200 cm"
  }, {
    name: "C. Bechstein A-208",
    value: "bis 210 cm"
  }, {
    name: "C. Bechstein A-228",
    value: "bis 230 cm"
  }, {
    name: "C. Bechstein B-203",
    value: "bis 210 cm"
  }, {
    name: "C. Bechstein B-212",
    value: "bis 220 cm"
  }, {
    name: "C. Bechstein C-234",
    value: "bis 250 cm"
  }, {
    name: "C. Bechstein D-282",
    value: "bis 290 cm"
  }, {
    name: "C. Bechstein L-167",
    value: "bis 170 cm"
  }, {
    name: "C. Bechstein M-180",
    value: "bis 180 cm"
  }, {
    name: "C. Bechstein M/P-192",
    value: "bis 200 cm"
  }, {
    name: "Blüthner 1",
    value: "bis 290 cm"
  }, {
    name: "Blüthner 2",
    value: "bis 250 cm"
  }, {
    name: "Blüthner 4",
    value: "bis 210 cm"
  }, {
    name: "Blüthner 6",
    value: "bis 190 cm"
  }, {
    name: "Blüthner 10",
    value: "bis 170 cm"
  }, {
    name: "Blüthner 11",
    value: "bis 160 cm"
  }, {
    name: "Bösendorfer 155",
    value: "bis 160 cm"
  }, {
    name: "Bösendorfer 170",
    value: "bis 180 cm"
  }, {
    name: "Bösendorfer 170 VC",
    value: "bis 180 cm"
  }, {
    name: "Bösendorfer 185 VC",
    value: "bis 190 cm"
  }, {
    name: "Bösendorfer 200",
    value: "bis 200 cm"
  }, {
    name: "Bösendorfer 214",
    value: "bis 220 cm"
  }, {
    name: "Bösendorfer 214 VC",
    value: "bis 220 cm"
  }, {
    name: "Bösendorfer 225",
    value: "bis 230 cm"
  }, {
    name: "Bösendorfer 280",
    value: "bis 290 cm"
  }, {
    name: "Bösendorfer 280 VC",
    value: "bis 290 cm"
  }, {
    name: "Bösendorfer 290 Imperial",
    value: "bis 290 cm"
  }, {
    name: "Boston GP-156",
    value: "bis 160 cm"
  }, {
    name: "Boston GP-163",
    value: "bis 170 cm"
  }, {
    name: "Boston GP-178",
    value: "bis 180 cm"
  }, {
    name: "Boston GP-193",
    value: "bis 200 cm"
  }, {
    name: "Boston GP-215",
    value: "bis 220 cm"
  }, {
    name: "Essex 155C",
    value: "bis 160 cm"
  }, {
    name: "Essex 175C",
    value: "bis 180 cm"
  }, {
    name: "Estonia 190",
    value: "bis 190 cm"
  }, {
    name: "Fazioli F-183",
    value: "bis 190 cm"
  }, {
    name: "Fazioli F-212",
    value: "bis 220 cm"
  }, {
    name: "Fazioli F-228",
    value: "bis 230 cm"
  }, {
    name: "Fazioli F-278",
    value: "bis 290 cm"
  }, {
    name: "Fazioli F-308",
    value: "bis 290 cm"
  }, {
    name: "Feurich 162 Dynamic I",
    value: "bis 170 cm"
  }, {
    name: "Feurich 171",
    value: "bis 180 cm"
  }, {
    name: "Feurich 179 Dynamic II",
    value: "bis 180 cm"
  }, {
    name: "Feurich 190",
    value: "bis 190 cm"
  }, {
    name: "Feurich 215",
    value: "bis 220 cm"
  }, {
    name: "Feurich 218 Concert I",
    value: "bis 220 cm"
  }, {
    name: "Feurich 227",
    value: "bis 230 cm"
  }, {
    name: "Förster 170",
    value: "bis 180 cm"
  }, {
    name: "Förster 190",
    value: "bis 190 cm"
  }, {
    name: "Förster 215",
    value: "bis 230 cm"
  }, {
    name: "Förster 275",
    value: "bis 290 cm"
  }, {
    name: "Grotrian-Steinweg 165 Chambre",
    value: "bis 170 cm"
  }, {
    name: "Grotrian-Steinweg 185",
    value: "bis 190 cm"
  }, {
    name: "Grotrian-Steinweg 189",
    value: "bis 190 cm"
  }, {
    name: "Grotrian-Steinweg 192 Cabinet",
    value: "bis 200 cm"
  }, {
    name: "Grotrian-Steinweg 208 Charis",
    value: "bis 210 cm"
  }, {
    name: "Grotrian-Steinweg 225 Concert",
    value: "bis 230 cm"
  }, {
    name: "Grotrian-Steinweg 277 Concert",
    value: "bis 290 cm"
  }, {
    name: "Grotrian-Steinweg G-165",
    value: "bis 170 cm"
  }, {
    name: "Grotrian-Steinweg G-192",
    value: "bis 200 cm"
  }, {
    name: "Grotrian-Steinweg G-208",
    value: "bis 210 cm"
  }, {
    name: "Grotrian-Steinweg G-225",
    value: "bis 230 cm"
  }, {
    name: "Grotrian-Steinweg G-277",
    value: "bis 290 cm"
  }, {
    name: "Ibach 183",
    value: "bis 190 cm"
  }, {
    name: "Kawai GE-3",
    value: "bis 180 cm"
  }, {
    name: "Kawai GE-20",
    value: "bis 170 cm"
  }, {
    name: "Kawai GE-30",
    value: "bis 180 cm"
  }, {
    name: "Kawai GM-2",
    value: "bis 160 cm"
  }, {
    name: "Kawai GM-10",
    value: "bis 160 cm"
  }, {
    name: "Kawai GL-10",
    value: "bis 160 cm"
  }, {
    name: "Kawai GL-30",
    value: "bis 170 cm"
  }, {
    name: "Kawai GL-50",
    value: "bis 190 cm"
  }, {
    name: "Kawai GS-30",
    value: "bis 190 cm"
  }, {
    name: "Kawai GS-40",
    value: "bis 200 cm"
  }, {
    name: "Kawai GX-1",
    value: "bis 170 cm"
  }, {
    name: "Kawai GX-2",
    value: "bis 180 cm"
  }, {
    name: "Kawai GX-3",
    value: "bis 190 cm"
  }, {
    name: "Kawai KF-1",
    value: "bis 170 cm"
  }, {
    name: "Kawai KG-2",
    value: "bis 180 cm"
  }, {
    name: "Kawai KG-2A",
    value: "bis 180 cm"
  }, {
    name: "Kawai KG-2C",
    value: "bis 180 cm"
  }, {
    name: "Kawai KG-2E",
    value: "bis 180 cm"
  }, {
    name: "Kawai KG-2D",
    value: "bis 180 cm"
  }, {
    name: "Kawai KG-3C",
    value: "bis 180 cm"
  }, {
    name: "Kawai KG-3D",
    value: "bis 190 cm"
  }, {
    name: "Kawai KG-5C",
    value: "bis 210 cm"
  }, {
    name: "Kawai RX-1",
    value: "bis 170 cm"
  }, {
    name: "Kawai RX-2",
    value: "bis 180 cm"
  }, {
    name: "Kawai RX-3",
    value: "bis 190 cm"
  }, {
    name: "Kawai RX-6",
    value: "bis 220 cm"
  }, {
    name: "Kawai SK-2 Shigeru",
    value: "bis 180 cm"
  }, {
    name: "Kawai SK-3 Shigeru",
    value: "bis 190 cm"
  }, {
    name: "Kawai SK-5 Shigeru",
    value: "bis 200 cm"
  }, {
    name: "Kawai SK-6 Shigeru",
    value: "bis 220 cm"
  }, {
    name: "Kawai SK-7 Shigeru",
    value: "bis 230 cm"
  }, {
    name: "Petrof 173 Breeze",
    value: "bis 180 cm"
  }, {
    name: "Petrof 194 Storm",
    value: "bis 200 cm"
  }, {
    name: "Petrof 210 Pasat",
    value: "bis 220 cm"
  }, {
    name: "Pleyel 190",
    value: "bis 190 cm"
  }, {
    name: "Sauter 160 Alpha",
    value: "bis 170 cm"
  }, {
    name: "Sauter 185 Delta",
    value: "bis 190 cm"
  }, {
    name: "Sauter 220 Omega",
    value: "bis 230 cm"
  }, {
    name: "Schimmel C-169",
    value: "bis 180 cm"
  }, {
    name: "Schimmel C-189",
    value: "bis 190 cm"
  }, {
    name: "Schimmel C-213",
    value: "bis 220 cm"
  }, {
    name: "Schimmel GP-169",
    value: "bis 170 cm"
  }, {
    name: "Schimmel K-169",
    value: "bis 170 cm"
  }, {
    name: "Schimmel K-175",
    value: "bis 180 cm"
  }, {
    name: "Schimmel K-189",
    value: "bis 190 cm"
  }, {
    name: "Schimmel K-195",
    value: "bis 200 cm"
  }, {
    name: "Schimmel K-213",
    value: "bis 220 cm"
  }, {
    name: "Schimmel K-230",
    value: "bis 250 cm"
  }, {
    name: "Schimmel 174-T",
    value: "bis 180 cm"
  }, {
    name: "Schimmel 182-T",
    value: "bis 190 cm"
  }, {
    name: "Schimmel 208-T",
    value: "bis 210 cm"
  }, {
    name: "Schimmel 205",
    value: "bis 210 cm"
  }, {
    name: "Seiler 168 Virtuoso",
    value: "bis 170 cm"
  }, {
    name: "Seiler 186 Maestro",
    value: "bis 180 cm"
  }, {
    name: "Seiler 208 Professional",
    value: "bis 210 cm"
  }, {
    name: "Seiler 242 Konzert",
    value: "bis 250 cm"
  }, {
    name: "Steinberg IQ-77",
    value: "bis 180 cm"
  }, {
    name: "Steinberg IQ-93",
    value: "bis 200 cm"
  }, {
    name: "Steingraeber & Söhne A-170",
    value: "bis 170 cm"
  }, {
    name: "Steingraeber & Söhne B-192",
    value: "bis 200 cm"
  }, {
    name: "Steingraeber & Söhne C-212",
    value: "bis 220 cm"
  }, {
    name: "Steingraeber & Söhne D-232",
    value: "bis 250 cm"
  }, {
    name: "Steingraeber & Söhne 205",
    value: "bis 210 cm"
  }, {
    name: "Steinway & Sons A-188",
    value: "bis 190 cm"
  }, {
    name: "Steinway & Sons B-211",
    value: "bis 220 cm"
  }, {
    name: "Steinway & Sons C-227",
    value: "bis 230 cm"
  }, {
    name: "Steinway & Sons D-274",
    value: "bis 275 cm"
  }, {
    name: "Steinway & Sons M-170",
    value: "bis 170 cm"
  }, {
    name: "Steinway & Sons O-180",
    value: "bis 180 cm"
  }, {
    name: "Steinway & Sons S-155",
    value: "bis 160 cm"
  }, {
    name: "W. Hoffmann P-162",
    value: "bis 170 cm"
  }, {
    name: "W. Hoffmann P-188",
    value: "bis 190 cm"
  }, {
    name: "W. Hoffmann P-206",
    value: "bis 210 cm"
  }, {
    name: "W. Hoffmann T-161",
    value: "bis 170 cm"
  }, {
    name: "W. Hoffmann T-177",
    value: "bis 180 cm"
  }, {
    name: "W. Hoffmann T-186",
    value: "bis 190 cm"
  }, {
    name: "W. Hoffmann V-158",
    value: "bis 160 cm"
  }, {
    name: "W. Hoffmann V-175",
    value: "bis 180 cm"
  }, {
    name: "W. Hoffmann V-183",
    value: "bis 190 cm"
  }, {
    name: "Yamaha C-1",
    value: "bis 170 cm"
  }, {
    name: "Yamaha C-2",
    value: "bis 180 cm"
  }, {
    name: "Yamaha C-3",
    value: "bis 190 cm"
  }, {
    name: "Yamaha C-3 Studio",
    value: "bis 190 cm"
  }, {
    name: "Yamaha C-5",
    value: "bis 200 cm"
  }, {
    name: "Yamaha C-6",
    value: "bis 220 cm"
  }, {
    name: "Yamaha C-7",
    value: "bis 230 cm"
  }, {
    name: "Yamaha CF-IIIS",
    value: "bis 275 cm"
  }, {
    name: "Yamaha CFX",
    value: "bis 275 cm"
  }, {
    name: "Yamaha G-1",
    value: "bis 160 cm"
  }, {
    name: "Yamaha G-2",
    value: "bis 180 cm"
  }, {
    name: "Yamaha G-3",
    value: "bis 190 cm"
  }, {
    name: "Yamaha G-5",
    value: "bis 200 cm"
  }, {
    name: "Yamaha G-7",
    value: "bis 230 cm"
  }, {
    name: "Yamaha GB-1",
    value: "bis 160 cm"
  }, {
    name: "Yamaha GC-1",
    value: "bis 170 cm"
  }, {
    name: "Yamaha GC-2",
    value: "bis 180 cm"
  }, {
    name: "Yamaha GH-1B",
    value: "bis 160 cm"
  }, {
    name: "Yamaha GP-1",
    value: "bis 160 cm"
  }, {
    name: "Yamaha S-3X",
    value: "bis 190 cm"
  }, {
    name: "Yamaha S-4",
    value: "bis 190 cm"
  }, {
    name: "Yamaha S-5X",
    value: "bis 200 cm"
  }, {
    name: "Yamaha S-6",
    value: "bis 220 cm"
  }, {
    name: "Yamaha S-6X",
    value: "bis 220 cm"
  }, {
    name: "Yamaha S-400",
    value: "bis 190 cm"
  }],
}, {
  type: "Digitalpiano Schutzhüllen",
  urlTail: "products/digitalpiano-schutzhullen",
  models: [{
    name: "Yamaha CLP-865/765/665 GP",
    value: "bis 150 cm lang",
  }, {
    name: "Yamaha CLP-835/735/635",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha CLP-825/725/625",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha CLP-845/745/645",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha CLP-895/795/695 GP",
    value: "bis 150 cm lang",
  }, {
    name: "Yamaha CLP-875/775/675",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha CLP-885/785/685",
    value: "bis 110 cm hoch",
  }, {
    name: "Yamaha N-1 Avant Grand",
    value: "bis 110 cm hoch",
  }, {
    name: "Yamaha N-1X Avant Grand",
    value: "bis 110 cm hoch",
  }, {
    name: "Yamaha N-3X Avant Grand",
    value: "bis 150 cm lang",
  }, {
    name: "Yamaha CSP-295 GP",
    value: "bis 150 cm lang",
  }, {
       name: "Yamaha CSP-295",
    value: "bis 110 cm hoch",
  }, {
      name: "Yamaha CSP-275/255",
    value: "bis 110 cm hoch",
  }, {
    name: "Yamaha CVP-909 GP",
    value: "bis 150 cm lang",
  }, {
    name: "Yamaha CVP-909",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha CVP-905",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha CVP-701",
    value: "bis 100 cm hoch",
  }, {
    name: "Yamaha NU-1 Avant Grand",
    value: "bis 110 cm hoch",
  }, {
    name: "Yamaha NU-1X Avant Grand",
    value: "bis 110 cm hoch",
  }, {
    name: "Yamaha N-2",
    value: "bis 110 cm hoch",
  }, {
    name: "Kawai CA-401",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CA-49",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CA-501",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CA-59",
    value: "bis 110 cm hoch",
  }, {
    name: "Kawai CA-701",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CA-79",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CA-901",
    value: "bis 110 cm hoch",
  }, {
    name: "Kawai CA-99",
    value: "bis 110 cm hoch",
  }, {
    name: "Kawai CN-201",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CN-29",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CN-301",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai CN-39",
    value: "bis 100 cm hoch",
  }, {
    name: "CASIO AP-750",
    value: "bis 100 cm hoch",
  }, {
    name: "CASIO GP-510/GP-310",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai NV-6 Novus",
    value: "bis 110 cm hoch",
  }, {
    name: "Kawai NV-5/NV-10",
    value: "bis 100 cm hoch",
  }, {
    name: "Kawai NV-5 S",
    value: "bis 110 cm hoch",
  }, {
    name: "Kawai NV-10 S",
    value: "bis 150 cm lang",
  }, {
    name: "Kawai NV-12",
    value: "bis 150 cm lang",
  }],
}];

let currentModelMap = [];

const utils = {};

const selectPianoCover = function () {
  const pianoModel = document.getElementById("klaviermodel").value;
  const piano = currentModelMap.models.find(item => item.name == pianoModel)
  
  if (piano) {
    const inputEl = document.querySelector(`.block-swatch input[value="${piano.value}"]`);

    inputEl.click();
//     inputEl.checked = true;
//     inputEl.setAttribute('checked', 'checked');  
  }
}

const populatePianoModelsSelect = function (modelMap) {
  const select = document.getElementById('klaviermodel');
  
  modelMap.models.forEach(model => {
    let option = document.createElement('option');
    
    option.setAttribute('value', model.name);
    option.appendChild(document.createTextNode(model.name));
    select.appendChild(option);
  })
}

/* RUN ON DOCUMENT LOAD */

const bootstrap = function () {
  
  /* Populate piano model select */
  
  const pathname = window.location.pathname;
  
  pianoModelMap.forEach(modelMap => {
    if (pathname.match(modelMap.urlTail)) {
      populatePianoModelsSelect(modelMap);
      currentModelMap = modelMap;
      
      /* Disable Lange radio buttons */
      /* WARNING!!! - It disables the first .block-swatch-list, so make sure Lange is always the first one */
      document.querySelector('.block-swatch-list').setAttribute('style', 'pointer-events: none;')
    }
  });
  
  const instrumentAnfrageButton = document.getElementById("instrumenten-anfrage");
  const instrumentAnfrageLink = document.getElementById("instrument-anfrage-link");
  
  const triggers = [instrumentAnfrageButton, instrumentAnfrageLink];
  
  triggers.forEach(element => {
    if (element) {
      element.addEventListener("click", function(e) {
        e.preventDefault();
        window.location.href = window.location.href + "#kontakt";
        const productTitle = document.querySelector('.product-meta__title').innerText;
        const textarea = document.querySelector("#kontakt-container textarea");
        if (textarea) {
          textarea.innerHTML = `Frage zu \"${productTitle}\"`;
          textarea.focus();
        }  
      });
    }
  })
  
  /* Check terms and conditions before checkout functionality */
  
  const checkoutButtons = document.querySelectorAll('.button[name="checkout"]');
  
  for (let i=0; i < checkoutButtons.length; i++) {
    checkoutButtons[i].addEventListener('click', function (e) {
      const checkbox = document.getElementById("agree");

      if (checkbox && !checkbox.checked) {
        e.preventDefault();
        alert("Bitte füllen Sie das markierte Feld aus.");
      }
    });    
  }
}

window.onload = function () {
  bootstrap();
}

/* LAST CHANGE: put bootstrap inside onload. Added checkout buttons checkbox logic inside bootstrap */


// Get the current window location's href
let currentURL = window.location.href;

// Function to check if a URL contains a Swiss domain
function isSwissDomain(url) {
    const domainPattern = /\.ch\//i; // Case-insensitive match for ".ch/"
    return domainPattern.test(url);
}

// Check if the current URL contains a Swiss domain
if (isSwissDomain(currentURL)) {
    const className = 'product-info-alert';
    
    // Select all elements with the specified class
    const elements = document.getElementsByClassName(className);
    
    // Hide the selected elements by setting their display property to "none"
    for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = "none";
    }
} 

